import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bank-summary-table',
  templateUrl: './bank-summary-table.component.html',
  styleUrls: ['./bank-summary-table.component.css']
})
export class BankSummaryTableComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
